import React from 'react';
import { useRipple } from '../hooks/useRipple';

const Button = ({
    children,
    variant = 'contained',
    color = 'primary',
    size = 'medium',
    fullWidth = false,
    disabled = false,
    type = 'button',
    onClick,
    className = '',
    ...props
}) => {
    const rippleRef = useRipple();

    const baseStyles = 'relative inline-flex items-center justify-center font-medium transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2';

    const sizeStyles = {
        small: 'px-3 py-1.5 text-sm',
        medium: 'px-4 py-2 text-base',
        large: 'px-6 py-3 text-lg'
    };

    const variantStyles = {
        contained: {
            primary: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white shadow-md hover:shadow-lg focus:ring-red-500',
            secondary: 'bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white shadow-md hover:shadow-lg focus:ring-purple-500',
            success: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white shadow-md hover:shadow-lg focus:ring-green-500',
            error: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white shadow-md hover:shadow-lg focus:ring-red-500'
        },
        outlined: {
            primary: 'border-2 border-red-500 text-red-600 hover:bg-red-50 focus:ring-red-500',
            secondary: 'border-2 border-purple-500 text-purple-600 hover:bg-purple-50 focus:ring-purple-500',
            success: 'border-2 border-green-500 text-green-600 hover:bg-green-50 focus:ring-green-500',
            error: 'border-2 border-red-500 text-red-600 hover:bg-red-50 focus:ring-red-500'
        },
        text: {
            primary: 'text-red-600 hover:bg-red-50 focus:ring-red-500',
            secondary: 'text-purple-600 hover:bg-purple-50 focus:ring-purple-500',
            success: 'text-green-600 hover:bg-green-50 focus:ring-green-500',
            error: 'text-red-600 hover:bg-red-50 focus:ring-red-500'
        },
        glass: {
            primary: 'backdrop-blur-sm bg-white/10 border border-white/20 text-gray-800 hover:bg-white/20 focus:ring-red-500',
            secondary: 'backdrop-blur-sm bg-white/10 border border-white/20 text-gray-800 hover:bg-white/20 focus:ring-purple-500',
            success: 'backdrop-blur-sm bg-white/10 border border-white/20 text-gray-800 hover:bg-white/20 focus:ring-green-500',
            error: 'backdrop-blur-sm bg-white/10 border border-white/20 text-gray-800 hover:bg-white/20 focus:ring-red-500'
        }
    };

    const disabledStyles = 'opacity-50 cursor-not-allowed pointer-events-none';
    const fullWidthStyles = 'w-full';

    const buttonStyles = [
        baseStyles,
        sizeStyles[size],
        variantStyles[variant][color],
        disabled && disabledStyles,
        fullWidth && fullWidthStyles,
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            ref={rippleRef}
            type={type}
            className={buttonStyles}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
